<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <large-base-card>
    <ik-nice-dialog
      v-model="returnDishDialog"
      width="fit-content"
    >
      <v-tabs
        v-model="tabs"
        grow
      >
        <v-tab>
          {{ $t('returnDish') }}
        </v-tab>
        <v-tab>
          {{ $t('discount') }}
        </v-tab>
      </v-tabs>
      <v-divider/>
      <v-tabs-items v-model="tabs">
        <v-tab-item>
          <v-data-table
            :headers="returnDishHeaders"
            :items="returnList"
            :items-per-page="10"
          >
            <template #item.tableNumber="{ item }">
              <div class="d-flex align-center py-1">
                <div class="ml-1">
                  <div class="font-weight-bold">
                    {{ item.name }}/{{ item.orderId }}
                  </div>
                </div>
              </div>
            </template>
            <template #item.returnTime="{ item }">
              <div class="d-flex align-center py-1">
                <div class="ml-1">
                  <div class="font-weight-bold">
                    {{ item.time }}
                  </div>
                </div>
              </div>
            </template>
            <template #item.checkPerson="{ item }">
              <div class="d-flex align-center py-1">
                <div class="ml-1">
                  <div class="font-weight-bold">
                    {{ item.servantName }}
                  </div>
                </div>
              </div>
            </template>
            <template #item.returnDish="{ item }">
              <div class="d-flex align-center py-1">
                <div class="ml-1">
                  <div class="font-weight-bold">
                    <b>{{ item.Dname }}</b> &times; {{ item.count }} = {{ item.fPrice }}
                  </div>
                </div>
              </div>
            </template>
            <template #item.returnReason="{ item }">
              <div class="d-flex align-center py-1">
                <div class="ml-1">
                  <div class="font-weight-bold">
                    {{ item.returnReason }}
                  </div>
                </div>
              </div>
            </template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item>
          <v-data-table
            :headers="discountDishHeaders"
            :items="discountList"
            :items-per-page="10"
          >
            <template #item.checkPerson="{ item }">
              <div class="d-flex align-center py-1">
                <div class="ml-1">
                  <div class="font-weight-bold">
                    {{ item.servantName }}
                  </div>
                </div>
              </div>
            </template>
            <template #item.returnTime="{ item }">
              <div class="d-flex align-center py-1">
                <div class="ml-1">
                  <div class="font-weight-bold">
                    {{ item.time }}
                  </div>
                </div>
              </div>
            </template>
            <template #item.discountPrice="{ item }">
              <div class="d-flex align-center py-1">
                <div class="ml-1">
                  <div class="font-weight-bold">
                    {{ item.value }}
                  </div>
                </div>
              </div>
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs-items>
    </ik-nice-dialog>
    <div class="d-flex align-center">
      <div class="text-h4">
        {{ $t('fastFind') }}
      </div>
      <v-spacer/>
      <div
        class="d-flex align-center"
        style="height: 48px;"
      >
        <v-icon>mdi-book</v-icon>
      </div>
    </div>
    <div
      class="mt-4"
    >
      <div
        class="d-flex align-center text-body-1 mb-6"
      >
        <div style="max-width: 70%">
          <div class="font-weight-bold">
            {{ $t('todayWorkStaff') }}
          </div>
          <div class="value text--secondary">
            {{ servantInfo.length }} {{ $t('people') }}
          </div>
        </div>
        <v-spacer/>
        <v-card
          class="text-caption"
          color="transparent"
          elevation="0"
          @click="$router.push('/Tables/person-manage')"
        >
          {{ $t('checkAll') }}
        </v-card>
      </div>
      <div class="text-body-1 mb-6">
        <div>
          <div class=" font-weight-bold">
            {{ $t('realTimeSaleData') }}
          </div>
          <div class="value text--secondary text-body-2">
            {{ $t('SalesChange') }}
          </div>
        </div>
        <v-spacer/>
        <div
          class="flex-grow-0"
          style="height: 120px"
        >
          <apexchart
            v-if="graphReady"
            :options="chartOption"
            :series="chartData"
            height="120"
            type="area"
            width="100%"
          />
        </div>
      </div>
      <div class="d-flex align-center text-body-1 mb-6">
        <div>
          <div class="font-weight-bold">
            {{ $t('rateOfTurnTable') }}
          </div>
          <div class="text-caption">
            {{ $t('meanOfRateOfTurnTable') }}
          </div>
          <div class="value text--secondary">
            {{ turnTableRate }}%
          </div>
        </div>
      </div>
      <div class="d-flex align-center text-body-1 mb-6">
        <div style="max-width: 70%">
          <div class="font-weight-bold">
            {{ $t('discountReturnTotal') }}
          </div>
          <div class="value text--secondary">
            {{ orderDiscountTotal + returnTotal | priceDisplay }}
          </div>
        </div>
        <v-spacer/>
        <v-card
          class="text-caption"
          color="transparent"
          elevation="0"
          @click="returnDishDialog=true"
        >
          {{ $t('checkAll') }}
        </v-card>
      </div>

      <div
        class="d-flex align-center text-body-1 mb-6"
        @click="$router.push('/Sales/dish-statistics')"
      >
        <div>
          <div class="font-weight-bold">
            {{ $t('foodDrinkSales') }}
          </div>
          <div class="value text--secondary">
            {{ dishTotal | priceDisplay }}({{ dishTotalCount }}{{ $t('one(unit)') }})/ {{
              drinkTotal | priceDisplay
            }}({{ drinkTotalCount }}{{ $t('one(unit)') }})
          </div>
        </div>
        <v-spacer/>
        <v-card
          class="text-caption"
          color="transparent"
          elevation="0"
          @click="$router.push('/Sales/dish-statistics')"
        >
          {{ $t('checkAll') }}
        </v-card>
      </div>
    </div>
  </large-base-card>
</template>

<script>
  import { getAllServantInfo, loadDashboardData } from '@/model/DashboardService'
  import dayjs from 'dayjs'
  import Table from '@/model/tableAndPerson/Table'
  import LargeBaseCard from '@/composable/LargeBaseCard'
  import { IkNiceDialog } from 'metaflow-js'
  import i18n from '@/i18n'

  export default {
    components: {
      LargeBaseCard,
      IkNiceDialog,
    },
    props: {
      date: {},
      info: {},
    },
    data () {
      return {
        tabs: null,
        returnDishHeaders: [
          {
            text: i18n.t('tableNumber'),
            value: 'tableNumber',
          },
          {
            text: i18n.t('time'),
            value: 'returnTime',
          },
          {
            text: i18n.t('staff'),
            value: 'checkPerson',
          },
          {
            text: i18n.t('returnContent'),
            value: 'returnDish',
          },
          {
            text: i18n.t('returnReason'),
            value: 'returnReason',
          },
        ],
        discountDishHeaders: [
          {
            text: i18n.t('staff'),
            value: 'checkPerson',
          },
          {
            text: i18n.t('time'),
            value: 'returnTime',
          },
          {
            text: i18n.t('price'),
            value: 'discountPrice',
          },
        ],

        returnDishDialog: null,
        servantInfo: [],
        tableList: [],
        chartOption: null,
        chartData: null,
        series: [],
        graphReady: false,
      }
    },
    computed: {
      turnTableRate () {
        const totalOrders = this.info.orderCount
        const tableCount = this.tableList.length || 1
        return Math.max((totalOrders - tableCount) / tableCount, 0) * 100
      },
      guestAvgPrice () {
        return this.info.guestAvgPrice
      },
      statisticData () {
        return this.info?.dishStatistic ?? []
      },
      drinkItems () {
        return this.statisticData.filter(d => d.categoryTypeId === '9')
      },
      otherItems () {
        return this.statisticData.filter(d => d.categoryTypeId !== '9')
      },
      dishTotalCount () {
        return this.otherItems.reduce((total, i) => {
          total += parseInt(i.totalCount)
          return total
        }, 0)
      },
      drinkTotalCount () {
        return this.drinkItems.reduce((total, i) => {
          total += parseInt(i.totalCount)
          return total
        }, 0)
      },
      dishTotal () {
        return this.otherItems.reduce((total, i) => {
          total += parseFloat(i.price) * i.totalCount
          return total
        }, 0)
      },
      drinkTotal () {
        return this.drinkItems.reduce((total, i) => {
          total += parseFloat(i.price) * i.totalCount
          return total
        }, 0)
      },
      returnTotal () {
        return this.info?.taxInfos?.content?.storno.reduce((total, i) => {
          total += parseFloat(i.price)
          return total
        }, 0)
      },
      orderDiscount () {
        return this.info?.taxInfos?.content?.discount.map(b => b.orderInfo).flat().map(it => it.value) ?? []
      },
      orderDiscountTotal () {
        return this.orderDiscount?.map(Number)?.reduce((x, y) => x + y, 0) ?? 0
      },
      returnList () {
        return this.billData?.content?.storno ?? []
      },
      discountList () {
        return this.info?.taxInfos?.content?.discount.map(b => b.orderInfo).flat()
      },

    },
    async mounted () {
      this.servantInfo = (await getAllServantInfo(this.date)).filter(it => it.todayTotal > 0)
      this.tableList = await Table.getList()
      await this.initGraph()
    },
    methods: {
      getDataFromTurnoverData (list) {
        return list?.map(d => d.spanTotal) ?? []
      },
      async initGraph () {
        this.graphReady = false
        const todayInfo = (await loadDashboardData(this.date)).spanTurnover
        const currentHour = dayjs().hour()
        const categories = []
        for (let start = currentHour - 10; start < currentHour + 1; start++) {
          categories.push(start + ':00')
        }

        const data = categories.map(c => {
          return todayInfo.result.find(th => th.smallSelector + ':00' === c)?.spanTotal ?? '0.00'
        })

        this.chartOption = {
          colors: ['#66bb6a'],
          plotOptions: {
            area: {
              fillTo: 'end',
            },
          },
          chart: {
            sparkline: {
              enabled: true,
            },
          },
          xaxis: {
            categories: categories,
          },
        }
        this.chartData = [{
          name: i18n.t('sales'),
          data: data,
        }]
        this.graphReady = true
      },
    },
  }
</script>
